import { createSlice } from "@reduxjs/toolkit";

const companySlice = createSlice({
  name: "company",
  initialState: {
    isLoading: false,
    isLoadingData: false,
    companyList: [],
    currentCompany: null,
    currentEmployee: null,
    currentCompanyProfile: {},
    currentWorking: {},
    currentOvertime: {},
    currentDocument: {
      documentTemplateResponse: {},
      documentSignatureResponse: [],
    },
    currentSignature: {},
    branchList: [],
    currentBranch: {},
    positionList: [],
    possitionOption: [],
    departmentList: [],
    organizationLevelList: [],
    companyInformation: {},
    departmentListOption: [],
    roles: [],
    notification: 0,
    fcmToken: null
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setIsLoadingData(state, action) {
      state.isLoadingData = action.payload;
    },
    setCompanyList(state, action) {
      state.companyList = action.payload;
    },
    setCurrentCompany(state, action) {
      state.currentCompany = action.payload;
    },
    setCurrentEmployee(state, action) {
      state.currentEmployee = action.payload;
    },
    setCurrentCompanyProfile(state, action) {
      state.currentCompanyProfile = action.payload;
    },
    setCurrentWorking(state, action) {
      state.currentWorking = action.payload;
    },
    setCurrentOvertime(state, action) {
      state.currentOvertime = action.payload;
    },
    setDocument(state, action) {
      state.currentDocument = action.payload;
    },
    setSignature(state, action) {
      state.currentSignature = action.payload;
    },
    setBranchList(state, action) {
      state.branchList = action.payload;
    },
    setCurrentBranch(state, action) {
      state.currentBranch = action.payload;
    },
    setDepartment(state, action) {
      state.departmentList = action.payload;
    },
    setPosition(state, action) {
      state.positionList = action.payload;
    },
    setPositionOption(state, action) {
      state.possitionOption = action.payload;
    },
    setOrganizationLevelListOption(state, action) {
      state.organizationLevelList = action.payload;
    },
    setCompanyInformation(state, action) {
      state.companyInformation = action.payload;
    },
    setDepartmentListOption(state, action) {
      state.departmentListOption = action.payload;
    },
    setRoles(state, action) {
      state.roles = action.payload;
    },
    setNotification(state, action) {
      state.notification = action.payload;
    },
    setFcmToken(state, action) {
      state.fcmToken = action.payload;
    },
  },
});

export const {
  setIsLoading,
  setIsLoadingData,
  setCompanyList,
  setCurrentCompany,
  setCurrentEmployee,
  setCurrentCompanyProfile,
  setCurrentWorking,
  setCurrentOvertime,
  setDocument,
  setSignature,
  setBranchList,
  setCurrentBranch,
  setDepartment,
  setPosition,
  setPositionOption,
  setOrganizationLevelListOption,
  setCompanyInformation,
  setDepartmentListOption,
  setRoles,
  setNotification,
  setFcmToken
} = companySlice.actions;
export default companySlice.reducer;
